import type { SessionDto } from "@bafe/api-client";
import { Card, Section, StatusPill } from "@bafe/ui";
import { Link } from "react-router";

import { ROLE_LABEL } from "../../lib/status";

export function ProfileSection({ session }: { session: SessionDto }) {
	return (
		<Section title="Profile" description="How Key identifies you across your organisations.">
			<Card className="flex flex-col gap-4">
				<Row label="Name" value={session.user.fullName} />
				<Row label="Email address" value={session.user.email} />
				<div className="flex flex-wrap items-center justify-between gap-2">
					<span className="text-sm text-(--text-secondary)">Email confirmed</span>
					{session.user.emailVerified ? (
						<StatusPill tone="positive">Confirmed</StatusPill>
					) : (
						<StatusPill tone="caution">Not confirmed</StatusPill>
					)}
				</div>
				<div className="flex flex-wrap items-center justify-between gap-2">
					<span className="text-sm text-(--text-secondary)">Two-factor authentication</span>
					{session.user.twoFactorEnabled ? (
						<StatusPill tone="positive">On</StatusPill>
					) : (
						<StatusPill tone="caution">Off</StatusPill>
					)}
				</div>
			</Card>

			<Section title="Organisations you belong to">
				<Card flush>
					<ul>
						{session.memberships.map((membership) => (
							<li
								key={membership.organisationId}
								className="flex flex-wrap items-center justify-between gap-2 border-b border-(--border-subtle) px-4 py-3 last:border-0"
							>
								<span className="text-sm text-(--text-primary)">{membership.organisationName}</span>
								<span className="text-sm text-(--text-secondary)">
									{ROLE_LABEL[membership.role]}
								</span>
							</li>
						))}
					</ul>
				</Card>
			</Section>

			<p className="max-w-prose text-sm text-(--text-secondary)">
				Change your password or set up two-factor authentication under{" "}
				<Link to="/user/settings/security" className="underline underline-offset-2">
					Security
				</Link>
				. To change the name or email address on your Key account,{" "}
				<Link to="/support?category=security" className="underline underline-offset-2">
					contact support
				</Link>{" "}
				so we can verify the request.
			</p>
		</Section>
	);
}

function Row({ label, value }: { label: string; value: string }) {
	return (
		<div className="flex flex-wrap items-baseline justify-between gap-2">
			<span className="text-sm text-(--text-secondary)">{label}</span>
			<span className="text-sm text-(--text-primary)">{value}</span>
		</div>
	);
}
